import { Label } from "@/components/ui/label";
import { Badge } from "@/components/ui/badge";
import { Checkbox } from "@/components/ui/checkbox";
import { X } from "lucide-react";

export function RoleSelector({ selected, onChange, availableRoles }) {
  const toggle = (role) => {
    if (selected.includes(role)) {
      onChange(selected.filter(r => r !== role));
    } else {
      onChange([...selected, role]);
    }
  };

  return (
    <div>
      <Label className="text-xs uppercase tracking-wider text-muted-foreground mb-1.5 block">Roles</Label>
      <div className="max-h-48 overflow-y-auto border border-border rounded-sm p-2 space-y-0.5 bg-secondary/10">
        {availableRoles.map(r => (
          <label
            key={r}
            className="flex items-center gap-2 py-1 px-2 rounded-sm hover:bg-secondary/30 cursor-pointer text-sm"
          >
            <Checkbox
              data-testid={`role-check-${r.replace(/\s+/g, '-').toLowerCase()}`}
              checked={selected.includes(r)}
              onCheckedChange={() => toggle(r)}
            />
            <span className="flex-1">{r}</span>
          </label>
        ))}
      </div>
      {selected.length > 0 && (
        <div className="flex flex-wrap gap-1 mt-2">
          {selected.map(r => (
            <Badge key={r} variant="secondary" className="text-xs">
              {r}
              <button className="ml-1 hover:text-red-400" onClick={() => toggle(r)}>
                <X className="w-2.5 h-2.5" />
              </button>
            </Badge>
          ))}
        </div>
      )}
    </div>
  );
}
